import { Operation } from '../../../__generated__/globalTypes'

import getFlagsString from '../GetFlags.graphql'

export type GetFlagsData = {
  flags: {
    name: string
  }[]
}

export type GetFlags = Operation<GetFlagsData>

export const GetFlags = (): GetFlags => ({
  query: getFlagsString,
  variables: undefined,
})
